var _defs, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text10, _text11, _text12, _text13, _text14, _text15, _text16, _text17, _text18, _text19, _text20, _text21, _text22, _text23, _text24, _text25, _text26, _text27, _text28, _text29, _text30, _text31, _text32, _text33, _text34, _text35, _text36, _g, _g2, _text37, _text38;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgButtonReadMore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 186.01 186.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{isolation:isolate;}.cls-1{font-size:15.59px;}.cls-1,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-17,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{fill:#221f20;}.cls-1,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{font-family:BrandonGrotesque-MediumItalic, Brandon Grotesque;font-weight:500;font-style:italic;}.cls-2{font-size:15.57px;}.cls-3{font-size:15.66px;}.cls-4{font-size:15.53px;}.cls-5{font-size:15.59px;}.cls-6{font-size:15.61px;}.cls-7{font-size:15.61px;}.cls-8{font-size:15.6px;}.cls-9{font-size:15.59px;}.cls-10{font-size:15.67px;}.cls-11{font-size:15.62px;}.cls-12{font-size:15.55px;}.cls-13{font-size:15.57px;}.cls-14{font-size:15.58px;}.cls-15{font-size:15.69px;}"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(124.68 19.51) rotate(26.47)"
  }, "R")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "matrix(0.84, 0.54, -0.54, 0.84, 133.33, 23.86)"
  }, "E")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(140.54 28.51) rotate(39.45)"
  }, "A")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(147.86 34.48) rotate(46.61)"
  }, "D")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "matrix(0.54, 0.84, -0.84, 0.54, 157.56, 45.15)"
  }, "M")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(164.21 55.65) rotate(66.15)"
  }, "O")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(168.85 66.31) rotate(73.74)"
  }, "R")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(171.52 75.63) rotate(80.39)"
  }, "E")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(172.96 102.71) rotate(100.41)"
  }, "R")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "matrix(-0.29, 0.96, -0.96, -0.29, 171.2, 112.27)"
  }, "E")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(168.76 120.46) rotate(113.23)"
  }, "A")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(165.08 129.16) rotate(120.67)"
  }, "D")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(157.52 141.44) rotate(131.39)"
  }, "M")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "matrix(-0.77, 0.64, -0.64, -0.77, 149.28, 150.76)"
  }, "O")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "matrix(-0.84, 0.54, -0.54, -0.84, 140.32, 158.2)"
  }, "R")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "matrix(-0.9, 0.44, -0.44, -0.9, 132.11, 163.37)"
  }, "E")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(110.19 171.61) rotate(171.38)"
  }, "R")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(100.6 173.02) rotate(177.71)"
  }, "E")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "matrix(-1, -0.07, 0.07, -1, 92.03, 173.35)"
  }, "A")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "matrix(-0.98, -0.2, 0.2, -0.98, 82.63, 172.69)"
  }, "D")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(68.54 169.54) rotate(-157.47)"
  }, "M")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    className: "cls-10",
    transform: "matrix(-0.86, -0.52, 0.52, -0.86, 57.09, 164.75)"
  }, "O")), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(47.14 158.66) rotate(-141.24)"
  }, "R")), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(39.59 152.55) rotate(-134.72)"
  }, "E")), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    className: "cls-11",
    transform: "translate(24.7 134.48) rotate(-117.33)"
  }, "R")), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    className: "cls-12",
    transform: "translate(20.25 125.88) rotate(-111.16)"
  }, "E")), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "matrix(-0.25, -0.97, 0.97, -0.25, 17.15, 117.86)"
  }, "A")), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    className: "cls-13",
    transform: "translate(14.77 108.77) rotate(-97.48)"
  }, "D")), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(13.22 94.4) rotate(-86.41)"
  }, "M")), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "matrix(0.21, -0.98, 0.98, 0.21, 14.02, 82)"
  }, "O")), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    className: "cls-14",
    transform: "matrix(0.34, -0.94, 0.94, 0.34, 16.55, 70.63)"
  }, "R")), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    className: "cls-15",
    transform: "translate(19.89 61.52) rotate(-63.43)"
  }, "E")), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "matrix(0.69, -0.72, 0.72, 0.69, 32.2, 41.59)"
  }, "R")), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(38.91 34.61) rotate(-39.87)"
  }, "E")), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "matrix(0.83, -0.55, 0.55, 0.83, 45.48, 29.09)"
  }, "A")), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(53.33 23.86) rotate(-26.21)"
  }, "D")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M66.84,6.38a.29.29,0,0,1,.21-.3L67.26,6a.2.2,0,0,1,.25.11l3.85,7.05h0l1.94-8.62a.29.29,0,0,1,.21-.24l.21-.06a.23.23,0,0,1,.27.17l3,10.06c.06.21,0,.37-.19.42l-1,.28c-.14,0-.27,0-.33-.24L73.81,8.49l0,0-1.61,7.64a.29.29,0,0,1-.21.23l-.24.07a.2.2,0,0,1-.25-.11L68.17,10H68.1l0,7a.33.33,0,0,1-.22.32l-1,.28c-.18,0-.31-.07-.31-.29Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M83.85,2.74c2.51-.29,4.57,1.75,4.87,4.36a6.07,6.07,0,0,1-5.12,7,4.56,4.56,0,0,1-4.86-4.31A6.09,6.09,0,0,1,83.85,2.74Zm-.23,9.76c2.08-.24,3.78-2.52,3.49-5-.22-1.9-1.58-3.36-3.28-3.17-2.06.24-3.77,2.57-3.49,5.06C80.56,11.26,81.93,12.69,83.62,12.5Z"
  }))), _text37 || (_text37 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "matrix(1, 0.02, -0.02, 1, 89.97, 13.25)"
  }, "R")), _text38 || (_text38 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(99.68 13.45) rotate(7.47)"
  }, "E")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonReadMore);
export default __webpack_public_path__ + "static/media/button-read-more.6adef40be222b5c435cbacf0898144eb.svg";
export { ForwardRef as ReactComponent };